import React from 'react';
import PropTypes from 'prop-types';
import './Metrics.scss';

const Metrics = ({ data }) => {
  return (
    <div className="metrics__wrap">
      <div className="flex flex-items-center flex-40-60 km__wrapper fill">
        <div className="container">
          {/* conditional text color rendering */}
          {(() => {
            if (data.name == 'Favorability') {
              if (data.value() < 50) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == 'Over(+)/Under(-) Budget') {
              if (data.value() > 0) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == 'Political Stress') {
              if (data.value() > 60) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == '% GDP Change') {
              if (data.value() < 0) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == 'Employment') {
              if (data.value() < 30) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == 'HRX') {
              if (data.value() < 60) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }

            } else if (data.name == 'Equity') {
              if (data.value() < 60) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else if (data.name == '% in Debt') {
              if (data.value() > 100) {
                return (
                  <div className="flex flex-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="metrics__icon"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <label className="under">{data.value()}</label>
                  </div>
                );
              } else {
                return <label className="over">{data.value()}</label>;
              }
            } else {
              return <label className="km_value">{data.value()}</label>;
            }
          })()}
        </div>
        <div className="container">
          <label className="km_name">{data.name}</label>
          <label className="km_text">{data.text()}</label>
        </div>
      </div>
    </div>
  );
};

Metrics.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Metrics;
